import React from 'react';
import styled from 'styled-components';
import HighlightParagraph from '@catalogo/ui-americanas-desktop-questions-and-answers-list/src/components/highlight-paragraph';
import AnswerBox from './answer-box';
import Feedback from './feedback';

const QuestionText = styled.div`
  > p {
    font-size: 14px;
    font-weight: 700;
    word-break: break-word;
  }
`;

const CreatedAt = styled.p`
  font-size: 13px;
  margin-bottom: 10px;
  color: ${({ theme }) => theme.grey.dark};
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

const QuestionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  padding: 20px 0;
  border-bottom: 2px solid #f5f5f5;

  &.last {
    border: none;
  }
`;

const Owner = styled.p`
  font-size: 12px;
  margin-top: 10px;
  color: #838383;
  font-weight: ${({ theme }) => theme.fontWeight.title};
`;

export const Question = ({ question, term, totalTermFound, isLast }) => (
  <QuestionWrapper className={isLast ? 'last' : ''}>
    <QuestionText>
      <HighlightParagraph term={term} text={question?.question} totalTermFound={totalTermFound} />
    </QuestionText>
    <Owner>por {question.owner.name}</Owner>
    <CreatedAt>{question.createdAt}</CreatedAt>
    <AnswerBox answer={question.answer} />
    <Feedback evaluation={question.evaluation} questionId={question.id} answerId={question.answer.id} />
  </QuestionWrapper>
);
